"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updatePaymentProviderHandler = updatePaymentProviderHandler;
var _updatePaymentProviderFailed = require("@ori-events/update-payment-provider-failed");
var _types = require("../types");
var _utils = require("../utils");
async function updatePaymentProviderHandler({
  detail: {
    paymentProviderId,
    placement
  }
}) {
  const response = await fetch(`${_types.RequestUrl.UpdatePaymentProvider}?paymentProviderId=${paymentProviderId}`, (0, _utils.getHttpRequestSettings)({
    placement
  }));
  const data = (0, _utils.convertToCamelCase)(await response.json());
  if ((0, _updatePaymentProviderFailed.isUpdatePaymentProviderFailedResponse)(data)) {
    const errorEvent = new CustomEvent(_updatePaymentProviderFailed.Name, {
      detail: data
    });
    window.dispatchEvent(errorEvent);
    return false;
  }
  return data;
}
